import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import DigitalAssetApi from '../generated/api/DigitalAsset';

export default (service: Servicelayer) => ({
  ...DigitalAssetApi(service),

  // Add custom calls here

});
